import { render, staticRenderFns } from "./InviteModal.vue?vue&type=template&id=12412e8e&scoped=true&"
import script from "./InviteModal.vue?vue&type=script&lang=js&"
export * from "./InviteModal.vue?vue&type=script&lang=js&"
import style0 from "./InviteModal.vue?vue&type=style&index=0&id=12412e8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12412e8e",
  null
  
)

export default component.exports